/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    color: inherit;
  }
`
export default class CommentsIco extends PureComponent {
  render() {
    return (
      <svg id="그룹_8499" data-name="그룹 8499" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" css={Color}>
        <path id="패스_8132" className="fill" data-name="패스 8132" d="M92.713,56.131a8.47,8.47,0,0,1-8.943,8.384,8.1,8.1,0,0,1-3.334-.92.651.651,0,0,0-.52-.056c-1.118.313-2.243.6-3.357.93-.267.078-.354-.088-.5-.206a.352.352,0,0,1-.11-.434c.314-1.127.623-2.256.918-3.388A.674.674,0,0,0,76.812,60a8.394,8.394,0,1,1,15.644-5.682c.127.6.174,1.207.258,1.812" transform="translate(-66.271 -38.129)" fill="#405060"/>
        <rect id="사각형_7266" data-name="사각형 7266" width="36" height="36" fill="#405060" opacity="0"/>
      </svg>
    )
  }
}
